<div class="wrapper gap-4 relative">
  @if (isLoading()) {
    <div class="relative min-h-10">
      <korviu-loader></korviu-loader>
    </div>
  } @else {
    <div class="documents-list flex flex-col gap-4" [class.mb-12]="!hideButtons" [class.md:mb-16]="!hideButtons">
      <div
        class="info-wrapper py-6 px-4 md:py-8 md:px-6 flex flex-col"
        [class.collapsed]="officialIdCollapsed()"
        [class.gap-4]="!officialIdCollapsed()"
      >
        <div class="info-wrapper-header flex flex-row justify-between">
          <span class="font-medium text-base md:text-lg">{{ 'profile.officialID' | translate }}</span>
          <div class="flex flex-row gap-2">
            <app-tag [type]="getBlockStatus(DocumentTypes.ID)?.type">
              {{ getBlockStatus(DocumentTypes.ID)?.localizableName | translate }}
            </app-tag>
            @if (collapsable) {
              <button nz-button nzType="text" class="collapse-button" (click)="onOfficialIdCollapseClick()">
                <i nz-icon>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                    <path
                      d="M19.7803 16.0303C19.4874 16.3232 19.0126 16.3232 18.7197 16.0303L12 9.3107L5.2803 16.0303C4.9874 16.3232 4.5126 16.3232 4.2197 16.0303C3.9268 15.7374 3.9268 15.2626 4.2197 14.9697L11.4697 7.7197C11.7626 7.4268 12.2374 7.4268 12.5303 7.7197L19.7803 14.9697C20.0732 15.2626 20.0732 15.7374 19.7803 16.0303Z"
                      fill="#505760"
                    />
                  </svg>
                </i>
              </button>
            }
          </div>
        </div>
        <div class="collapsable-content flex flex-col gap-4 relative">
          @if (getDeclinedReasons(DocumentTypes.ID)?.length) {
            <div class="flex flex-col gap-2">
              @for (reason of getDeclinedReasons(DocumentTypes.ID); track reason.id) {
                <app-alert [closable]="false" [type]="'danger'">
                  [{{ reason?.documentName }}] {{ 'profile.declined' | translate }}:
                  <span class="font-medium">{{ reason?.reason }}</span
                  >. {{ 'profile.pleaseTryAgainWith' | translate }}
                </app-alert>
              }
            </div>
          }
          <div class="info-wrapper-description">
            @if (isUsAccount) {
              <span class="text-base md:text-lg">{{ 'profile.toConfirmYourIdentityUS' | translate }}</span>
            } @else {
              <span class="text-base md:text-lg">{{ 'profile.toConfirmYourIdentity' | translate }}</span>
            }
          </div>
          <div class="upload">
            @if (officialIdShowLinks) {
              <div class="flex flex-col gap-2">
                @for (file of documentation?.officialId; track file.id) {
                  <ng-container [ngTemplateOutlet]="linkTemp" [ngTemplateOutletContext]="{ file }"></ng-container>
                }
              </div>
            } @else {
              <app-upload
                [dragAndDrop]="true"
                [hideUploadButton]="!officialIdEditMode"
                [statuses]="officialIdStatuses"
                [(fileList)]="documentation.officialIdFiles"
                (fileListChange)="onOfficialIdFileChange($event)"
              ></app-upload>
            }
          </div>
        </div>
      </div>

      @if (!isUsAccount) {
        <div
          class="info-wrapper py-6 px-4 md:py-8 md:px-6 flex flex-col"
          [class.collapsed]="taxStatusCollapsed()"
          [class.gap-4]="!taxStatusCollapsed()"
        >
          <div class="info-wrapper-header flex flex-row justify-between">
            <span class="font-medium text-base md:text-lg">{{ 'profile.taxStatusCertificate' | translate }}</span>
            <div class="flex flex-row gap-2">
              <app-tag [type]="getBlockStatus(DocumentTypes.TAX)?.type">
                {{ getBlockStatus(DocumentTypes.TAX)?.localizableName | translate }}
              </app-tag>
              @if (collapsable) {
                <button nz-button nzType="text" class="collapse-button" (click)="onTaxStatusCollapseClick()">
                  <i nz-icon>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
                      <path
                        d="M19.7803 16.0303C19.4874 16.3232 19.0126 16.3232 18.7197 16.0303L12 9.3107L5.2803 16.0303C4.9874 16.3232 4.5126 16.3232 4.2197 16.0303C3.9268 15.7374 3.9268 15.2626 4.2197 14.9697L11.4697 7.7197C11.7626 7.4268 12.2374 7.4268 12.5303 7.7197L19.7803 14.9697C20.0732 15.2626 20.0732 15.7374 19.7803 16.0303Z"
                        fill="#505760"
                      />
                    </svg>
                  </i>
                </button>
              }
            </div>
          </div>
          <div class="collapsable-content flex flex-col gap-4 relative">
            @if (getDeclinedReasons(DocumentTypes.TAX)?.length) {
              <div class="flex flex-col gap-2">
                @for (reason of getDeclinedReasons(DocumentTypes.TAX); track reason.id) {
                  <app-alert [closable]="false" [type]="'danger'">
                    [{{ reason?.documentName }}] {{ 'profile.declined' | translate }}:
                    <span class="font-medium">{{ reason?.reason }}</span
                    >. {{ 'profile.pleaseTryAgainWith' | translate }}
                  </app-alert>
                }
              </div>
            }
            <div class="info-wrapper-description">
              <span class="text-base md:text-lg">{{ 'profile.pleaseProvideACopy' | translate }}</span>
            </div>
            <div class="upload">
              @if (taxShowLinks) {
                <div class="flex flex-col gap-2">
                  @for (file of documentation?.tax; track file.id) {
                    <ng-container [ngTemplateOutlet]="linkTemp" [ngTemplateOutletContext]="{ file }"></ng-container>
                  }
                </div>
              } @else {
                <app-upload
                  [dragAndDrop]="true"
                  [hideUploadButton]="!taxEditMode"
                  [statuses]="taxStatuses"
                  [(fileList)]="documentation.taxFiles"
                  (fileListChange)="onTaxFileChange($event)"
                ></app-upload>
              }
            </div>
          </div>
        </div>
      }
    </div>
    @if (!hideButtons) {
      <div class="buttons w-full flex flex-row gap-4 md:gap-8">
        <korviu-button class="flex-1" color="ghost" (onclick)="onBackClick()">
          {{ 'profile.addAccount.back' | translate }}
        </korviu-button>
        <korviu-button class="flex-1" color="tertiary" [disabled]="!formIsValid" (onclick)="onSubmitClick()">
          {{ 'common.submit' | translate }}
        </korviu-button>
      </div>
    }
  }
</div>

<ng-template #linkTemp let-file="file">
  <button
    type="button"
    class="file-link cursor-pointer flex flex-row gap-2 w-full justify-center items-center bg-transparent border-0 p-0 disabled:opacity-50"
    [disabled]="openingDocumentId() !== null"
    [attr.aria-busy]="openingDocumentId() === file.id"
    (click)="openDocument(file)"
  >
    <i nz-icon>
      <svg xmlns="http://www.w3.org/2000/svg" width="23" height="23" viewBox="0 0 23 23" fill="none">
        <path
          d="M17.2389 4.72454C15.2151 2.70071 11.9194 2.70071 9.89768 4.72454L4.29025 10.3277C4.25373 10.3642 4.23439 10.4136 4.23439 10.4652C4.23439 10.5167 4.25373 10.5661 4.29025 10.6027L5.08303 11.3954C5.11926 11.4315 5.16832 11.4518 5.21945 11.4518C5.27059 11.4518 5.31964 11.4315 5.35588 11.3954L10.9633 5.79231C11.6594 5.09622 12.5854 4.71379 13.5694 4.71379C14.5533 4.71379 15.4793 5.09622 16.1733 5.79231C16.8694 6.4884 17.2518 7.41438 17.2518 8.39622C17.2518 9.3802 16.8694 10.304 16.1733 11.0001L10.4584 16.7128L9.53244 17.6388C8.66662 18.5046 7.25939 18.5046 6.39357 17.6388C5.97463 17.2198 5.74475 16.6634 5.74475 16.0704C5.74475 15.4775 5.97463 14.921 6.39357 14.5021L12.0633 8.8345C12.2072 8.6927 12.3963 8.61321 12.5983 8.61321H12.6004C12.8024 8.61321 12.9893 8.6927 13.1311 8.8345C13.275 8.97844 13.3524 9.1675 13.3524 9.36946C13.3524 9.56926 13.2729 9.75833 13.1311 9.90012L8.49689 14.53C8.46037 14.5665 8.44104 14.6159 8.44104 14.6675C8.44104 14.7191 8.46037 14.7685 8.49689 14.805L9.28967 15.5978C9.32591 15.6339 9.37496 15.6541 9.42609 15.6541C9.47723 15.6541 9.52628 15.6339 9.56252 15.5978L14.1946 10.9657C14.6221 10.5382 14.8563 9.97102 14.8563 9.36731C14.8563 8.7636 14.6199 8.19426 14.1946 7.76887C13.3115 6.88586 11.8764 6.88801 10.9934 7.76887L10.4434 8.32102L5.3258 13.4364C4.97846 13.7817 4.70314 14.1926 4.51579 14.6451C4.32844 15.0976 4.23279 15.5828 4.23439 16.0726C4.23439 17.0673 4.62326 18.0019 5.3258 18.7044C6.05412 19.4306 7.00803 19.7937 7.96193 19.7937C8.91584 19.7937 9.86975 19.4306 10.5959 18.7044L17.2389 12.0657C18.2164 11.0861 18.7578 9.78196 18.7578 8.39622C18.76 7.00832 18.2186 5.70422 17.2389 4.72454Z"
          fill="#007DCB"
        />
      </svg>
    </i>
    <span class="text-base md:text-lg font-light">{{ file.name }}</span>
  </button>
</ng-template>
